/* stratos-artcrop.js  (2026-08-14, client notes round 4)

   Two jobs now.

   1. The automatic white-margin trim is REMOVED.

      Susanna, 2026-08-07: "Since this state is unacceptable, I understand the
      only option is to reverse these changes. Please change back to square
      shape image holders and ... let's change the background colour to simple
      white, so the white margins will not show up."

      Susanna, 2026-08-13: "there is a lot of unevenness and missing part of the
      images. Here the margin of the art works itself is partialy or entitrely
      missing."

      Rounds 2 and 3 measured the white bands baked into her image files and
      trimmed them with a canvas pass. That is what produced both the uneven
      cards and, on works whose paper margin is close in tone to the band, a
      trim that ate into the artwork. Every image is now rendered exactly as the
      store serves it, letterboxed and centred inside a uniform square holder
      painted white by stratos-tiles.css, so a baked-in white band is
      indistinguishable from the holder and no pixel of any artwork is cut.

      sxArtcropScan is kept as a no-op because layout/theme.liquid calls it
      after rendering the cart page's recently-viewed grid.

   2. Three collection-card corrections from her 2026-08-13 note.

      This file is deferred, so it runs after the inline script inside
      sections/stratos-collection.liquid. Doing the work here keeps that
      working section file untouched. All three are presentation only: the
      server HTML, the product data and the page structure are unchanged.

      a) Sold works sort to the end of the grid.
         "Please sort the colletions so that the 'Sold' artworks appear at the
         end of the collections, only after the available ones."
         Note this orders the cards on the page being viewed. Collections
         longer than one page (48 works) still paginate in the store's own
         order, so a sold work on page 2 stays on page 2.

      b) A medium sitting in the middle of a title is dropped.
         "the format of the title of Dali sculptures does not allow the title
         of the sculpture to be visible. It might just need 'Bronze Sculpture'
         from the title to be removed."
         Those sculptures belong to no artist collection, so the section's
         existing trim never removed the leading artist segment, and its medium
         rules only look at the first and last segments. "Salvador Dali, Bronze
         Sculpture, Alice in Wonderland" therefore arrived whole and clamped to
         two lines, hiding the actual title.

      c) The red line above a card is hidden when it only repeats the page
         heading. "the 'Sculpture Collection' in red is also not necessary."
         Where a real artist is identified, for example the sculptor names on
         Contemporary Sculptures, the line still shows. */

window.sxArtcropScan = function () {};

(function () {
  var MEDIUM = /^(original\s+|unique\s+|hand[\s-]?(signed|coloured|colored)\s+|exclusive\s+)*(lithograph|etching|engraving|heliogravure|woodcut|wood\s+engraving|linocut|aquatint|serigraph|seriolithograph|silkscreen|screen\s?print|giclee|giclée|watercolou?r|drawing|gouache|mixed\s+media|oil\s+on\s+\w+|acrylic|sculpture|stone\s+sculpture|bronze\s+sculpture|bronze|tapestry|poster|print|monotype|mezzotint|drypoint|collage|ceramic|photogravure|pochoir|paper\s?cut|mourlot)\s*$/i;

  function trim(s) { return (s || '').replace(/^\s+|\s+$/g, ''); }

  function norm(s) {
    s = trim(s).toLowerCase().replace(/\s+/g, ' ');
    try { s = s.normalize('NFD').replace(/[̀-ͯ]/g, ''); } catch (e) {}
    return s;
  }

  /* (b) drop a medium segment wherever it sits in the title */
  function dropInteriorMedium(root) {
    var titles = root.querySelectorAll('.sxc-title');
    for (var i = 0; i < titles.length; i++) {
      var n = titles[i];
      var t = trim(n.textContent);
      if (t.indexOf(',') === -1) continue;
      var parts = t.split(',');
      var kept = [];
      for (var j = 0; j < parts.length; j++) {
        if (!MEDIUM.test(trim(parts[j]))) kept.push(trim(parts[j]));
      }
      /* never blank a title: only rewrite when something real survives */
      if (kept.length && kept.length < parts.length) n.textContent = kept.join(', ');
    }
  }

  /* (c) hide the red line when it only repeats the page heading */
  function hideRedundantEyebrow(root) {
    var head = root.querySelector('.sxc-display');
    if (!head) return;
    var pageTitle = norm(head.textContent);
    if (!pageTitle) return;
    var eyebrows = root.querySelectorAll('.sxc-artist');
    for (var i = 0; i < eyebrows.length; i++) {
      if (norm(eyebrows[i].textContent) === pageTitle) eyebrows[i].style.display = 'none';
    }
  }

  /* (a) sold works to the end of the grid, original order otherwise preserved */
  function soldLast(root) {
    var grids = root.querySelectorAll('.sxc-grid');
    for (var g = 0; g < grids.length; g++) {
      var grid = grids[g];
      var cards = [].slice.call(grid.querySelectorAll(':scope > .sxc-card'));
      if (!cards.length) continue;
      var sold = [];
      for (var i = 0; i < cards.length; i++) {
        if (cards[i].querySelector('.sxc-price.is-sold')) sold.push(cards[i]);
      }
      if (!sold.length || sold.length === cards.length) continue;
      for (var k = 0; k < sold.length; k++) grid.appendChild(sold[k]);
    }
  }

  /* (d) Price Inquiry: send the artist and the price through to the gallery.
     Susanna 2026-08-13: "Can you include the price of the artwork in the
     Inquiry email to me?" Works priced on request still carry a price in
     Shopify, it is only hidden from the shop front, so the value is read from
     the product's own JSON rather than from the page. Every contact[...] field
     is reproduced in the notification the gallery receives. */
  function enrichInquiry() {
    var form = document.querySelector('form#sxd-inq-form, form.sxd-inq-form');
    if (!form || form.getAttribute('data-sx-enriched')) return;
    var m = window.location.pathname.match(/\/products\/([^\/?#]+)/);
    if (!m) return;
    form.setAttribute('data-sx-enriched', '1');

    function addField(name, value) {
      if (!value) return;
      if (form.querySelector('input[name="contact[' + name + ']"]')) return;
      var i = document.createElement('input');
      i.type = 'hidden';
      i.name = 'contact[' + name + ']';
      i.value = value;
      form.appendChild(i);
    }

    var eyebrow = document.querySelector('.sxd-artist, .sxd-label');
    if (eyebrow) addField('Artist', trim(eyebrow.textContent));

    try {
      fetch('/products/' + m[1] + '.js', { credentials: 'same-origin' })
        .then(function (r) { return r.ok ? r.json() : null; })
        .then(function (d) {
          if (!d) return;
          var cents = (d.price != null) ? d.price : (d.variants && d.variants[0] && d.variants[0].price);
          if (cents == null) return;
          var amount = (cents / 100).toFixed(2).replace(/\B(?=(\d{3})+(?!\d))/g, ',');
          addField('Price', '$' + amount + ' CAD');
          if (d.vendor) addField('Reference', d.handle);
        })
        .catch(function () {});
    } catch (e) {}
  }

  /* (e) Price Inquiry: confirm to the sender that the message went.
     Susanna 2026-08-07: "When requesting a Price Inquiry, it would be nice to
     display a quick confirmation to the sender." Shopify returns to the page
     with contact_posted=true once the message is accepted. */
  function inquiryConfirmation() {
    if (window.location.search.indexOf('contact_posted=true') === -1) return;
    if (document.querySelector('.sx-inq-ok')) return;
    var box = document.createElement('div');
    box.className = 'sx-inq-ok';
    box.setAttribute('role', 'status');
    var head = document.createElement('strong');
    head.textContent = 'Thank you, your inquiry has been sent.';
    var sub = document.createElement('span');
    sub.textContent = 'The gallery will reply to you by email shortly.';
    var close = document.createElement('button');
    close.type = 'button';
    close.setAttribute('aria-label', 'Close');
    close.textContent = '×';
    box.appendChild(head);
    box.appendChild(sub);
    box.appendChild(close);
    document.body.appendChild(box);
    close.onclick = function () { if (box.parentNode) box.parentNode.removeChild(box); };
    setTimeout(function () { if (box.parentNode) box.parentNode.removeChild(box); }, 12000);
  }

  function run() {
    try { enrichInquiry(); } catch (e) {}
    try { inquiryConfirmation(); } catch (e) {}
    var root = document.getElementById('sxc-root');
    if (!root) return;
    try { dropInteriorMedium(root); } catch (e) {}
    try { hideRedundantEyebrow(root); } catch (e) {}
    try { soldLast(root); } catch (e) {}
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', function () { run(); setTimeout(run, 500); });
  } else {
    run();
    setTimeout(run, 500);
  }
})();
